import cn from 'classnames';
import { memo } from 'react';

import { ITagCard } from '../../utils/types/state-types';
import ArrowRightUpIcon from '../SVGIcons/ArrowRightUpIcon';
import classes from './division-card.module.scss';

interface IDivisionCardProps {
  card: {
    title: string;
    tags: ITagCard[];
    to: string;
  };
  className?: string;
}

function DivisionCard({ card, className }: IDivisionCardProps) {
  if (!card) {
    return null;
  }

  return (
    <a
      href={card.to}
      className={cn(classes['main-header-division-card'], className)}
    >
      <div className={classes['main-header-division-card__link']}>
        <span className={classes['main-header-division-card__link-text']}>
          {card.title}
        </span>
        <ArrowRightUpIcon
          className={classes['main-header-division-card__link-icon']}
        />
      </div>
      <div className={cn(classes['main-header-division-card__tag-list'])}>
        {card.tags.map((tag) => (
          <div
            key={tag.id}
            className={classes['main-header-division-card__tag-item']}
          >
            {tag.value}
          </div>
        ))}
      </div>
    </a>
  );
}

export default memo(DivisionCard);
